import { Platform } from './CustomerService';

import { httpClient } from '@/lib/httpClient';

export interface LoginDto {
  email: string;
  password: string;
}

export interface LoginResponse {
  token: string;
}

export enum CustomerLogoStatus {
  PENDING = 'PENDING',
  UPLOADING = 'UPLOADING',
  UPLOADED = 'UPLOADED',
  ERROR = 'ERROR',
}

export interface MeResponse {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  role: {
    id: number;
    name: string;
  };
  customer: {
    id: number;
    publicId: string;
    name: string;
    group: string | null;
    url: string;
    platform: Platform;
    vtexUrl: string;
    fetchedProducts: boolean;
    freemium: boolean;
    freemiumFetchedProducts: boolean;
    hubspotToken: string | null;
    taxonomyVersion: string | null;
    vtexAppKey: string | null;
    vtexAppToken: string | null;
    vtexAffiliateUrl: string | null;
    vtexAffiliateId: string | null;
    vtexSalesChannel: number | null;
    shopifyUrl: string | null;
    shopifyAccessToken: string | null;
    meta_user_token: string | null;
    meta_business_id: string;
    meta_catalog_id: string;
    meta_page_id: string | null;
    meta_ad_account_id: string | null;
    omnichatApiKey: string | null;
    omnichatApiSecret: string | null;
    visionCategoriesAvailable: string | null;
    visionLastSubmission: Date | null;
    visionAutoRun: boolean;
    singleSkuVision: boolean;
    needUpdateCategoryName: boolean;
    language: string;
    seoLanguage: string;
    additionalSeoLanguage: string[];
    shopifyPublicationIds?: string | null;
    shopifyExcludedVendors?: string | null;
    shopifyOrderSource?: string | null;
    logoObjectKey?: string | null;
    logoStatus?: CustomerLogoStatus;
    logoUpdateData?: Date | null;
  };
}

export interface ChangePasswordDto {
  currentPassword: string;
  newPassword: string;
}

export interface ChangePasswordResponse {
  message: string;
}

export interface ViewerDto {
  customerId: number;
}

class AuthService {
  constructor() {}

  async login(loginDto: LoginDto) {
    const { data } = await httpClient.post<LoginResponse>(
      '/v1/auth/email/login',
      loginDto,
    );

    return { token: data.token };
  }

  async me() {
    const { data } = await httpClient.get<MeResponse>('/v1/auth/me');

    return data;
  }

  async changePassword(changePasswordDto: ChangePasswordDto) {
    const { data } = await httpClient.post<ChangePasswordResponse>(
      '/v1/auth/change/password',
      changePasswordDto,
    );

    return data;
  }

  async viewer(viewerDto: ViewerDto) {
    const { data } = await httpClient.post<LoginResponse>(
      '/v1/auth/viewer',
      viewerDto,
    );

    return data;
  }
}

export default new AuthService();
